import React, { useState, useRef, useEffect } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { Card, CardBody } from 'reactstrap';
import { updateDocumentTitle, toggleErrorDialog } from 'actions';
import {
    useGetLinkpayDetailQuery,
    useUpdateLinkpayDetailMutation
} from 'redux/hook/useLinkPay';
import NavigationBar from 'components/NavigationBar';
import ChargeFunctionGroup from './ChargeFunctionGroup';
import FlexGroup from 'components/FlexGroup';
import { Refresh } from 'components/Pagination';
import AuthView from 'components/AuthView';
import ErrorMessage from 'components/ErrorMessage';
import Form from 'components/Form';
import FormGroup from 'components/Form/FormGroup';
import Input, {
    TYPE_TEXT,
    TYPE_DATETIME,
    TYPE_SELECT,
    TYPE_NUMBER,
    TYPE_TEXTAREA
} from 'components/Form/Input';
import './nonuser-charge-detail.scss'
import CopyToClipBoard from 'components/CopyToClipBoard';
import NonUserChargeStatus from './NonUserChargeStatus';
import ReissueInvoice from "components/ReissueInvoice";
import {
    NONUSER_CHARGE_EXPENSE_TYPE_GROUP,
    NONUSER_CHARGE_STATUS_SUCCESS
} from 'constants/nonuser-charge';
import { AUTH_VIEW_LINK_PAY_DETAIL } from 'constants/permission';

const COMMENTS = 'comments';
const EXPENSE_TYPE = 'expense_type';

const NonUserChargeDetail = () => {
    const dispatch = useDispatch();
    const formRef = useRef();
    const [isEdit, setIsEdit] = useState(false);
    const [comments, setComments] = useState();
    const i18n = useSelector(state => state.i18n);
    const { linkPayId } = useParams();
    const {
        data: linkpayDetail,
        error: linkpayDetailError,
        refetch: getLinkpayDetail,
    } = useGetLinkpayDetailQuery(linkPayId);
const [updateLinkpayDetail] = useUpdateLinkpayDetailMutation();
    useEffect(() => {
        dispatch(updateDocumentTitle('additional_fee.fee_detail_title'));
    }, [dispatch, i18n]);

    useEffect(() => {
            if (!isEdit) {
                setComments(linkpayDetail?.expense_comments || '');
            }
        }, [isEdit, linkpayDetail]);

    const getNonuserExpenseTypeOptions = () => {
        return NONUSER_CHARGE_EXPENSE_TYPE_GROUP.map(value => ({
            name: I18n.t(`nonuser_charge.nonuser_expense_type_map.${ value }`),
            value: value,
        }));
    };

    const handleFormChange = e => {
        const { name, value } = e.target;
        switch (name) {
            case COMMENTS:
                setComments(value);
                break;
            default:
        }
    };

    const handleUpdate = async (params) => {
        try {
            const { error } = await updateLinkpayDetail(params);
            if (error) {
                throw error;
            }
            else {
                getLinkpayDetail(linkPayId);
                setIsEdit(false);
            }
        }
        catch (error) {
            const message = I18n.t('general_error_message');

            dispatch(toggleErrorDialog(message));
        }
    };

    const handleEdit = () => {
        let params={
            id: linkPayId,
            expense_comments: comments,
        };

        return handleUpdate(params);
    };

    return (
        <AuthView className="nonuserChargeDetail">
            {
                linkpayDetailError ? (
                    <ErrorMessage error={linkpayDetailError} />
                ) : (
                    <>
                        <NavigationBar title={ linkpayDetail?.title } sticky>
                            <ChargeFunctionGroup
                                isEdit={ isEdit }
                                linkpayDetail={ linkpayDetail }
                                onRevoke={ handleUpdate }
                                onEditUpdate={ handleEdit }
                                onChangEdit={ (status) => setIsEdit(status) }
                            />
                        </NavigationBar>
                        <section className="detail-block">
                            <FlexGroup end>
                                {
                                    isEdit ? null : (
                                        <Refresh
                                            time={ moment(linkpayDetail?.updatedTime) }
                                            onClick={ () => { getLinkpayDetail(linkPayId) } }
                                        />
                                    )
                                }
                            </FlexGroup>
                        </section>
                        <Form
                            innerRef={ formRef }
                            onChange={ handleFormChange }
                            className="detail-form"
                            inline
                            stopSubmitByEnter
                        >
                            <FlexGroup className="cards" alignStart>
                                <Card className="column">
                                    <CardBody>
                                        <FormGroup className="charge-detail" title={ I18n.t('nonuser_charge.details') }>
                                            {
                                                linkpayDetail?.expired ? (
                                                    <>

                                                        <Input
                                                            type={ TYPE_TEXT }
                                                            caption="nonuser_charge.payment_link"
                                                            value={
                                                                <>
                                                                    <Translate className="invalid-link" value={`(${ I18n.t('nonuser_charge.invalid_link')})`} />
                                                                    { linkpayDetail?.payment_link }
                                                                </>
                                                            }
                                                            viewMode
                                                        />
                                                    </>
                                                ) : (
                                                    <div className="control-group view-mode">
                                                        <h5 className="caption">{ I18n.t('nonuser_charge.payment_link') }</h5>
                                                        <span className="inline-wrapper">
                                                            <CopyToClipBoard>
                                                                <a
                                                                    className="view-control"
                                                                    href={ linkpayDetail?.payment_link }
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    { linkpayDetail?.payment_link }
                                                                </a>
                                                            </CopyToClipBoard>
                                                        </span>
                                                    </div>
                                                )
                                            }
                                            <Input
                                                name="schedule_time"
                                                type={ TYPE_DATETIME }
                                                caption="nonuser_charge.create_time"
                                                dateFormat="YYYY-MM-DD"
                                                timeFormat="HH:mm"
                                                value={ linkpayDetail?.create_time }
                                                viewMode
                                            />
                                            <Input
                                                type={ TYPE_TEXT }
                                                caption="nonuser_charge.case_name"
                                                value={ linkpayDetail?.title }
                                                viewMode
                                            />
                                            <Input
                                                name={ EXPENSE_TYPE }
                                                type={ TYPE_SELECT }
                                                caption="nonuser_charge.expense_type"
                                                value={ getNonuserExpenseTypeOptions() }
                                                selected={ linkpayDetail?.expense_type }
                                                viewMode
                                            />
                                            <div className="control-group view-mode">
                                                <h5 className="caption">{ I18n.t('nonuser_charge.status') }</h5>
                                                <span className="inline-wrapper">
                                                    <NonUserChargeStatus type={ linkpayDetail?.status } badge />
                                                </span>
                                            </div>
                                            <Input
                                                type={ TYPE_TEXT }
                                                caption="rental.invoice_no"
                                                value={ linkpayDetail?.invoice_no }
                                                unitCaption={ !isEdit ? (
                                                    <ReissueInvoice
                                                        id={ linkpayDetail?.link_pay_id }
                                                        entryType={ AUTH_VIEW_LINK_PAY_DETAIL }
                                                        isValid={ linkpayDetail?.status === NONUSER_CHARGE_STATUS_SUCCESS }
                                                        price={ linkpayDetail?.amount }
                                                        onSuccess={ () => { getLinkpayDetail(linkPayId) } }
                                                    />
                                                ) : null }
                                                viewMode
                                            />
                                            <Input
                                                type={ TYPE_NUMBER }
                                                caption="rental.price"
                                                value={ linkpayDetail?.amount }
                                                viewMode
                                            />
                                        </FormGroup>
                                        <FormGroup
                                            className="comment-wrapper"
                                            title={ I18n.t('additional_fee.comments') }
                                            withBadge={ <span className="subtitle">{ I18n.t('additional_fee.comments_ps')}</span>  }
                                        >
                                            <Input
                                                className="comments"
                                                name={ COMMENTS }
                                                type={ TYPE_TEXTAREA }
                                                rows={ 4 }
                                                value={ comments }
                                                withCaption={ false }
                                                viewMode={ !isEdit }
                                            />
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                            </FlexGroup>
                        </Form>
                    </>
                )
            }
        </AuthView>
    )
}

export default NonUserChargeDetail
